<template>
    <a href="javascript:;" :class="{'doctor-list--heart': true, 'on': favoYn}" @click="favoAddDel" v-if="info.type == 'DOCTOR' && !info.doctorDetail"></a>
    <button type="button" :class="{'btn': true, 'active': favoYn}"  @click="favoAddDel" v-else-if="info.type == 'DOCTOR' && info.doctorDetail">
        <span class="icon"></span>
        <span class="mo-none">관심의료진</span>
    </button>
    <a href="javascript:;" :class="{'table--heart': true, 'on': favoYn}" @click="favoAddDel" v-else-if="info.type == 'BBS' && info.mypageYn"></a>
    <a href="javascript:;" :class="{'heart': true, 'active': favoYn}" @click="favoAddDel" v-else></a>
</template>

<script>
export default {
    props: {
        info: Object
    },
    data() {
        return {
            favoYn: this.info.favoYn == 'Y' ? true : false
        }
    },
    methods: {
        favoAddDel() {
            const path = this.$route.path
            if(this.$store.getters.getStatus){
                const txt = this.info.type == 'DOCTOR' ? '의료진' : '콘텐츠'
                if(this.info.favoYn == 'Y'){
                    if (confirm(`관심 ${txt}을(를) 해제하시겠습니까?`)) {
                        this.axios
                            .post(this.api.favorite.delete, null, {
                                params: {
                                    favoNo: this.info.no,
                                    favoTypeCd: this.info.type
                                }
                            })
                            .then(res => {
                                if (res.status == 200) {
                                    alert(`해당 ${txt}이(가) 즐겨찾기에서 해제되었습니다.`);
                                    if(this.$parent.searchBoardNo){
                                        this.$emit('getList', this.$parent.searchBoardNo)
                                    }else{
                                        this.$emit('getList')
                                    }

                                    this.favoYn = false
                                    this.info.favoYn = 'N'
                                } else {
                                    alert('오류가 발생하였습니다. 다시 시도해주시길 바랍니다.');
                                }
                            })
                    }
                }else{
                    this.axios
                        .get(this.api.favorite.add, {
                            params: {
                                favoNo: this.info.no,
                                favoTypeCd: this.info.type
                            }
                        })
                        .then(res => {
                            if (res.status == 200) {
                                this.favoYn = true
                                this.info.favoYn = 'Y'

                                alert(`해당 ${txt}이(가) 즐겨찾기에 등록되었습니다. 내 진료정보 > 관심 ${txt}에서 확인하실 수 있습니다.`);
                            } else {
                                alert('오류가 발생하였습니다. 다시 시도해주시길 바랍니다.');
                            }
                        })
                }
            }else{
                alert('로그인 후 이용하실 수 있습니다.')
                // const url = this.$route.path.indexOf('/deptHp/') > -1 ? `/deptHp/${this.$route.params.deptCd}/${this.$route.params.hpUrl}/member/deptLogin.do` : '/member/login.do'
                this.$router.push('/kr/login')
            }
        },
    },
    mounted() {
        
    },
}
</script>